import { FunctionComponent } from 'react'
import { useLocation } from 'wouter'
import ArchiveIcon from './Icon/ArchiveIcon'
import DailyBoardPreview from './DailyBoardPreview'
import IconClose from './IconClose'
import LargeMenuItem from './LargeMenuItem'
import LettergramsIcon from '../img/lettergrams.svg'
import manageConsent from '../util/manageConsent'
import MenuItem from './MenuItem'
import StackdownIcon from '../img/stackdown-icon.svg'
import WaffleIcon from '../img/waffle-icon.svg'

type MenuProps = {
	active: boolean
	onClose: () => void
	openModal: (modalName: string) => void
}

const Menu: FunctionComponent<MenuProps> = ({ active, onClose, openModal }) => {
	const [, navigate] = useLocation()

	let className = 'menu'
	if (active) className += ' menu--active'

	return (
		<nav className={className}>
			<header>
				<h1>Menu</h1>
				<IconClose onClick={onClose} />
			</header>

			<LargeMenuItem
				label="Daily Search"
				description="The original 5x5 wordsearch"
				image={<DailyBoardPreview />}
				onClick={() => {
					navigate('/')
					onClose()
				}}
			/>
			<LargeMenuItem
				label="Archive"
				description="Searching for more?"
				image={<ArchiveIcon />}
				onClick={() => {
					navigate(`/archive`)
					onClose()
				}}
			/>

			<hr />

			<LargeMenuItem
				label="Waffle"
				description="The original breakfast classic"
				image={<img src={WaffleIcon} />}
				onClick={() => window.open('https://wafflegame.net')}
			/>
			<LargeMenuItem
				label="Stackdown"
				description="The original pile of tiles"
				image={<img src={StackdownIcon} />}
				onClick={() => window.open('https://puzzlist.com/stackdown')}
			/>
			<LargeMenuItem
				label="Lettergrams"
				description="Your daily word quest"
				image={<img src={LettergramsIcon} />}
				onClick={() => window.open('https://puzzlist.com/lettergrams')}
			/>

			<hr />

			<MenuItem iconName="statistics" onClick={() => openModal('stats')}>
				Statistics
			</MenuItem>
			<MenuItem iconName="settings" onClick={() => openModal('settings')}>
				Settings
			</MenuItem>
			<MenuItem iconName="how-to-play" onClick={() => openModal('help')}>
				Help
			</MenuItem>
			<div style={{ flexGrow: 1 }} />
			<div className="menu__footer">
				<a
					href="https://puzzlist.com/onewordsearch/privacy.html"
					target="_blank"
					rel="noreferrer"
				>
					Privacy Policy
				</a>
				<span onClick={manageConsent}>data consent</span>
			</div>
		</nav>
	)
}

export default Menu
